import { render, staticRenderFns } from "./EditCorpEventReceiverDialog.vue?vue&type=template&id=f9be1a02"
import script from "./EditCorpEventReceiverDialog.vue?vue&type=script&lang=js"
export * from "./EditCorpEventReceiverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports